import { useNavigate } from 'react-router-dom';
import Pagination from '../../../../features/Pagination/Pagination';
import { GetCurrencySymbol } from '../../../../utils/Currency';
import { TableSortArrow } from '../../../../utils/IconComp';
import { GetFloatNumber } from '../../../../utils/NumberFormatter';
import { GetDate } from '../../../../utils/Show';
import { mkRelativeUrl } from '../../../../utils/URL';
import cn from '../../../../utils/cn';

function TableHeader({ onSortedHandler, sortBy, sortedColumn }) {
    return (
        <thead>
            <tr>
                <th onClick={() => onSortedHandler('id')} scope="col">
                    <span className="uppercase">Id</span>
                    <TableSortArrow name="id" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>
                <th onClick={() => onSortedHandler('invoice-id')} scope="col" className="w-30">
                    <span>Invoice ID</span>
                    <TableSortArrow name="invoice-id" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>
                <th onClick={() => onSortedHandler('gateway')} scope="col" className="w-30">
                    <span>Gateway</span>
                    <TableSortArrow name="gateway" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>
                <th onClick={() => onSortedHandler('user')} scope="col">
                    <span>Customer</span>
                    <TableSortArrow name="user" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>
                <th
                    onClick={() => onSortedHandler('date-initiate')}
                    scope="col"
                    className="w-32 !px-1 text-center"
                >
                    <span>Initiate Date</span>
                    <TableSortArrow
                        name="date-initiate"
                        sortedColumn={sortedColumn}
                        sortBy={sortBy}
                    />
                </th>
                <th
                    onClick={() => onSortedHandler('date-success')}
                    scope="col"
                    className="w-32 !px-1 text-center"
                >
                    <span>Success Date</span>
                    <TableSortArrow
                        name="date-success"
                        sortedColumn={sortedColumn}
                        sortBy={sortBy}
                    />
                </th>
                <th
                    onClick={() => onSortedHandler('currency')}
                    scope="col"
                    className="w-30 text-center"
                >
                    <span>Currency</span>
                    <TableSortArrow name="currency" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>
                <th
                    onClick={() => onSortedHandler('amount')}
                    scope="col"
                    className="w-30 text-center"
                >
                    <span>Amount</span>
                    <TableSortArrow name="amount" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>
                <th
                    onClick={() => onSortedHandler('status')}
                    scope="col"
                    className="!w-28 text-center !cursor-pointer"
                >
                    <span>Status</span>
                    <TableSortArrow name="status" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>
            </tr>
        </thead>
    );
}

function Tr({ item }) {
    const navigate = useNavigate();

    return (
        <tr className={cn(`group`, { 'placeholder-mode': item?.demo })}>
            <td>
                <span className="uppercase">{item?.id}</span>
            </td>
            <td
                className="group-hover:font-medium group-hover:text-secondary cursor-pointer hover:underline"
                onClick={() =>
                    navigate(mkRelativeUrl(`/billing/invoices/${item?.invoiceId}/info`), {
                        state: {
                            title: 'Receipt'
                        }
                    })
                }
            >
                <span>{item?.invoiceId}</span>
            </td>
            <td className="capitalize">
                <span>{item?.gateway || '---'}</span>
            </td>
            <td
                className="group-hover:font-medium group-hover:text-secondary cursor-pointer hover:underline"
                onClick={() =>
                    navigate(
                        mkRelativeUrl(`/customers/${item?.userId}/info/`, {
                            tab: 'payments'
                        })
                    )
                }
            >
                <span>{item?.organization || item?.fullName}</span>
            </td>
            <td className="text-center">
                <span>{GetDate(item?.timeInitiate) || '---'}</span>
            </td>
            <td className="text-center">
                <span>{GetDate(item?.timeSuccess) || '---'}</span>
            </td>
            <td className="text-center">
                <span>{item?.currency}</span>
            </td>
            <td className="text-center">
                <span>
                    {GetCurrencySymbol(item?.currency)}
                    {GetFloatNumber(item?.amount)}
                </span>
            </td>
            <td className="!pr-8">
                <span
                    className={`block capitalize ${
                        item?.status === 'paid' ? 'text-success' : 'text-warning'
                    }`}
                >
                    {item?.status}
                </span>
            </td>
        </tr>
    );
}

function TransactionPageTable({ data, onChangePage, onSortedHandler, sortBy, sortedColumn }) {
    return (
        <div className="customer_page_table mb-52">
            <table className="bik-table">
                <TableHeader
                    onSortedHandler={onSortedHandler}
                    sortBy={sortBy}
                    sortedColumn={sortedColumn}
                />

                <tbody>
                    {data.transactions && data?.transactions?.length === 0 ? (
                        <tr className="hover:!bg-inherit">
                            <td colSpan={8} className="!text-left">
                                No Transaction Found!
                            </td>
                        </tr>
                    ) : (
                        data?.transactions?.map((item) => <Tr key={item?.id} item={item} />)
                    )}
                </tbody>
            </table>
            <Pagination data={data?.pagination || {}} onChangePage={onChangePage} />
        </div>
    );
}

export default TransactionPageTable;
